<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: "pgcManage"
  }
</script>

<style scoped>
</style>
